import {computed, Injectable, signal} from '@angular/core';
import {ApiError} from '@core/types';

type GlobalErrorState = {
  status?: number;
  error?: ApiError;
};

@Injectable({
  providedIn: 'root'
})
export class ErrorService {
  private state = signal<GlobalErrorState>({});

  setError(error: ApiError, status?: number): void {
    this.state.set({error, status});
  }

  clear(): void {
    this.state.set({});
  }

  status = computed(() => this.state().status ?? null);
  message = computed(() => this.state().error?.message || 'Ocurrió un error inesperado');
  details = computed(() => this.state().error?.details);
}
